/* eslint-disable import/prefer-default-export */
import { DialogsRootState } from './types';

export const selectConfirmationDialog = (state: DialogsRootState) => state.dialogs.confirm;
